import React from 'react';
import { BRAND_STORY } from '../data/brandStory';
import { Icon } from './icons';

export default function BrandStory() {
  return (
    <section className="section" style={{ background: 'var(--surface)' }}>
      <div className="container">
        <h2 className="section-title">왜 KOA DETAILING인가</h2>
        <p className="section-subtitle">
          우리가 추구하는 가치와 비전
        </p>
        <div className="brand-mission-vision">
          <div className="brand-block">
            <span className="brand-label" style={{ color: 'var(--primary)' }}>MISSION</span>
            <p className="brand-text">{BRAND_STORY.mission}</p>
          </div>
          <div className="brand-block">
            <span className="brand-label" style={{ color: 'var(--accent)' }}>VISION</span>
            <p className="brand-text">{BRAND_STORY.vision}</p>
          </div>
        </div>
        <div className="gradient-divider" />
        <div className="brand-values">
          {BRAND_STORY.values.map((v, i) => (
            <div key={i} className="brand-value-card">
              <div className="icon-glow" style={{ color: 'var(--primary)' }}>
                <Icon name={v.icon} size={32} />
              </div>
              <h3 style={{ fontSize: '1.1rem', fontWeight: 600, marginBottom: 8 }}>{v.title}</h3>
              <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', lineHeight: 1.5 }}>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
